import React from 'react';
export function SocialProofBar() {
  return <section className="w-full py-12 px-4" style={{
    background: 'linear-gradient(180deg, #0a1510 0%, #0d1f17 50%, #0a1510 100%)'
  }} data-id="element-362">
      <div className="max-w-5xl mx-auto" data-id="element-363">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mb-12 text-center" data-id="element-364">
          <div data-id="element-365">
            <div className="text-3xl sm:text-4xl font-black text-[#00E68A]" data-id="element-366">
              +3.000
            </div>
            <div className="text-gray-300 text-xs sm:text-sm font-semibold mt-1" data-id="element-367">
              docentes confían
            </div>
          </div>
          <div data-id="element-368">
            <div className="text-3xl sm:text-4xl font-black text-[#00E68A]" data-id="element-369">
              6
            </div>
            <div className="text-gray-300 text-xs sm:text-sm font-semibold mt-1" data-id="element-370">
              Tomos listos
            </div>
          </div>
          <div data-id="element-371">
            <div className="text-3xl sm:text-4xl font-black text-[#00E68A]" data-id="element-372">
              4.9/5
            </div>
            <div className="text-gray-300 text-xs sm:text-sm font-semibold mt-1" data-id="element-373">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-374">
            <div className="text-3xl sm:text-4xl" data-id="element-375">🇦🇷</div>
            <div className="text-gray-300 text-xs sm:text-sm font-semibold mt-1" data-id="element-376">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-377">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E68A]/30 rounded-xl p-4" data-id="element-378">
            <div className="w-10 h-10 rounded-full bg-[#00E68A]/20 border border-[#00E68A]/40 flex items-center justify-center text-[#00E68A] font-black text-sm flex-shrink-0" data-id="element-379">
              VM
            </div>
            <div data-id="element-380">
              <div className="text-[#00E68A] text-xs mb-1" data-id="element-381">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-382">
                "Organicé todo el año de Lengua en una tarde. Nunca más llegué
                sin material al aula. El solucionario me ahorra horas cada
                semana."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-383">
                — Valeria M., Córdoba | Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E68A]/30 rounded-xl p-4" data-id="element-384">
            <div className="w-10 h-10 rounded-full bg-[#00E68A]/20 border border-[#00E68A]/40 flex items-center justify-center text-[#00E68A] font-black text-sm flex-shrink-0" data-id="element-385">
              CR
            </div>
            <div data-id="element-386">
              <div className="text-[#00E68A] text-xs mb-1" data-id="element-387">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-388">
                "Mis clases de secundaria por fin tienen estructura real. Las
                secuencias didácticas están perfectamente pensadas para el
                alumno argentino."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-389">
                — Claudia R., Rosario | Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00E68A]/30 rounded-xl p-4" data-id="element-390">
            <div className="w-10 h-10 rounded-full bg-[#00E68A]/20 border border-[#00E68A]/40 flex items-center justify-center text-[#00E68A] font-black text-sm flex-shrink-0" data-id="element-391">
              MT
            </div>
            <div data-id="element-392">
              <div className="text-[#00E68A] text-xs mb-1" data-id="element-393">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-394">
                "Nunca más llegué sin material a clase. El Tomo de argumentación
                de 4° año es el hit del curso. Vale cada peso."
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-395">
                — Marcelo T., Buenos Aires | Secundaria
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}